import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { SchoolSiteOrderFieldEnum as Fields } from 'Common/FieldEnum';
import { Main, Filter } from 'Containers/';
import { SCHOOL_SITE_ORDER_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { errorToast, successToast } from 'Common/ToastHelper';
import { getVendorForCurrentSite } from 'State/filters/actions';
import { LoadingBase } from 'Components/';

import { SchoolSiteOrderForm } from './components/SchoolSiteOrderForm';
import * as SchoolSiteOrderActions from './state/actions';
import * as SchoolSiteOrderSelectors from './state/selectors';

const now = moment().format(DATE_FORMAT_FOR_UI);
const toDate = moment()
  .add(1, 'month')
  .format(DATE_FORMAT_FOR_UI);

class SchoolSiteOrder extends Component {
  componentDidMount() {
    const { getVendorForCurrentSite } = this.props;
    getVendorForCurrentSite();
  }

  componentDidUpdate(prevProps) {
    const { clearError, setSaveMessage, saveMessage } = this.props;

    errorToast(this.props, prevProps, 'error', clearError);
    successToast(this.props, prevProps, 'saveMessage', saveMessage, () =>
      setSaveMessage(null)
    );
  }

  get mainProps() {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        shown: true,
        isReadOnly,
        formName: SCHOOL_SITE_ORDER_FORM_NAME,
        saveButtonProps: {
          content: 'Place Order',
        },
      },
    };
  }

  handleSubmit = formValues => {
    const { createSiteOrder } = this.props;
    const formValuesCopy = { ...formValues };

    // Distributor doesn't exist, so set to null
    if (formValues[Fields.DistributorId] === 0) {
      formValuesCopy[Fields.DistributorId] = null;
    }

    createSiteOrder(formValuesCopy);
  };

  render() {
    const { fetching } = this.props;

    return (
      <Fragment>
        {fetching && <LoadingBase />}
        <Filter title="School Site Order" />
        <Main shouldNotUsePageWidth {...this.mainProps}>
          <SchoolSiteOrderForm
            initialValues={{
              [Fields.StartServingDT]: now,
              [Fields.EndServingDT]: toDate,
              [Fields.IsDeliverOnServingDate]: false,
            }}
            onSubmit={this.handleSubmit}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  startDate: SchoolSiteOrderSelectors.getStartDate(state),
  endDate: SchoolSiteOrderSelectors.getEndDate(state),
  error: SchoolSiteOrderSelectors.getError(state),
  saveMessage: SchoolSiteOrderSelectors.getSaveMessage(state),
  fetching: SchoolSiteOrderSelectors.getFetching(state),
});

const mapDispatchToProps = {
  createSiteOrder: SchoolSiteOrderActions.createSiteOrder,
  clearError: SchoolSiteOrderActions.clearError,
  setSaveMessage: SchoolSiteOrderActions.setSaveMessage,
  getVendorForCurrentSite,
};

SchoolSiteOrder = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SchoolSiteOrder)
);

export { SchoolSiteOrder };



// WEBPACK FOOTER //
// ./src/pages/schoolsiteorder/SchoolSiteOrder.js